import { Minus, Plus, Trash2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Sheet, SheetContent, SheetTitle, SheetDescription } from "./ui/sheet";
import { useCart } from "../lib/cart";
import { money } from "../lib/api";

const Line = ({ it, setQty }) => (
  <li className="flex gap-4 py-4 border-b-2 border-dashed border-[var(--ink)]/20" data-testid={`cart-item-${it.slug}`}>
    <img src={it.image} alt={it.name} className="w-20 h-20 rounded-2xl object-cover border-2 border-[var(--ink)]" />
    <div className="flex-1 min-w-0">
      <p className="font-display font-extrabold leading-tight">{it.name}</p>
      {it.color && <p className="text-sm text-[#5a5470]">{it.color}</p>}
      <div className="flex items-center justify-between mt-2">
        <div className="flex items-center rounded-full border-2 border-[var(--ink)] bg-white">
          <button onClick={() => setQty(it.key, it.qty - 1)} data-testid={`cart-minus-${it.slug}`} className="w-8 h-8 grid place-items-center" aria-label="Decrease">
            {it.qty === 1 ? <Trash2 className="w-3.5 h-3.5" /> : <Minus className="w-3.5 h-3.5" />}
          </button>
          <span className="w-6 text-center font-mono-x text-sm font-bold">{it.qty}</span>
          <button onClick={() => setQty(it.key, it.qty + 1)} data-testid={`cart-plus-${it.slug}`} className="w-8 h-8 grid place-items-center" aria-label="Increase">
            <Plus className="w-3.5 h-3.5" />
          </button>
        </div>
        <span className="font-mono-x font-bold">{money(it.price * it.qty)}</span>
      </div>
    </div>
  </li>
);

export const CartDrawer = () => {
  const { items, setQty, total, open, setOpen } = useCart();
  const nav = useNavigate();
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent data-testid="cart-drawer" data-lenis-prevent className="w-full sm:max-w-md bg-[var(--paper)] border-l-[2.5px] border-[var(--ink)] flex flex-col p-0 [&>button]:z-20 [&>button]:bg-white [&>button]:rounded-full [&>button]:p-2 [&>button]:border-2 [&>button]:border-[var(--ink)] [&>button]:opacity-100 [&>button]:right-4 [&>button]:top-4">
        <div className="p-6 border-b-2 border-[var(--ink)] bg-[var(--yellow)]">
          <SheetTitle className="font-display font-extrabold text-3xl tracking-tight">Your cart</SheetTitle>
          <SheetDescription className="text-[#3b3550]">Pay by bank transfer at checkout.</SheetDescription>
        </div>
        <div className="flex-1 overflow-y-auto px-6">
          {items.length === 0 ? (
            <p className="py-16 text-center font-display text-xl" data-testid="cart-empty">Your cart is empty. Go find something fun!</p>
          ) : (
            <ul>{items.map((it) => <Line key={it.key} it={it} setQty={setQty} />)}</ul>
          )}
        </div>
        <div className="p-6 border-t-2 border-[var(--ink)] bg-white">
          <div className="flex justify-between font-display font-extrabold text-xl mb-4">
            <span>Subtotal</span><span data-testid="cart-subtotal" className="font-mono-x">{money(total)}</span>
          </div>
          <button data-testid="cart-checkout-btn" disabled={!items.length} onClick={() => { setOpen(false); nav("/checkout"); }}
            className="w-full press chunk-sm rounded-full bg-[var(--ink)] text-[var(--paper)] font-bold py-4 disabled:opacity-40 disabled:pointer-events-none">
            Checkout
          </button>
        </div>
      </SheetContent>
    </Sheet>
  );
};
